export default "__VITE_ASSET__DTIxaeIb__"